module.exports = __webpack_public_path__ + "static/media/iceexperience.de5736ac.webp";